import { render, staticRenderFns } from "./IntelAvatar.vue?vue&type=template&id=cac58570&lang=pug&"
import script from "./IntelAvatar.vue?vue&type=script&lang=js&"
export * from "./IntelAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports